var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showErrorPage),expression:"showErrorPage"}],staticClass:"container-error-page"},[_c('h2',[_vm._v("Error 404")]),_c('p',[_vm._v("Esta página no existe")]),_c('router-link',{staticClass:"button",attrs:{"to":"/"}},[_vm._v("Volver al inicio")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }